export default __webpack_public_path__ + "static/media/1.d3399193.png";